import { render } from "./PastureView.vue?vue&type=template&id=7f50d06c&scoped=true&bindings={}"
import script from "./PastureView.vue?vue&type=script&lang=ts"
export * from "./PastureView.vue?vue&type=script&lang=ts"

import "./PastureView.vue?vue&type=style&index=0&lang=scss"
import "./PastureView.vue?vue&type=style&index=1&id=7f50d06c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f50d06c"

export default script